import {Component, Inject, OnInit} from '@angular/core';
import {Ofwca} from "../../../../shared/interface/ofwca";
import {Partner} from "../../../../shared/interface/partner";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {
  RegistrationAddDialogData
} from "../../../registrations/registration-add-dialog/registration-add-dialog.component";
import {Contract} from "../../../../shared/interface/contract";


export interface StatementAddDialogData {
  ofwcaId?: string;
  partnerId?: string;
}

@Component({
  selector: 'app-statement-add-dialog',
  templateUrl: './statement-add-dialog.component.html',
  styleUrls: ['./statement-add-dialog.component.scss']
})
export class StatementAddDialogComponent implements OnInit {
  ofwcaId?: string = null;
  partnerId?: string = null;

  constructor(
    public dialogRef: MatDialogRef<StatementAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: StatementAddDialogData,
  ) {
    this.ofwcaId = data.ofwcaId;
    this.partnerId = data.partnerId;
  }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
